<div class="p-4 md:p-12">
  @switch (state | async) {
    @case (BbitPaymentRedirectState.SUCCESS) {
      <div class="flex flex-row items-center mb-6">
        <ng-icon name="heroCheckCircle" size="32px" class="mr-4 text-green-400"></ng-icon>
        <h1 class="mb-0">{{ { key: 'thankYouForYourOrder' } | i18n }}</h1>
      </div>

      <p>{{ { key: 'orderSuccessfullySavedInfo' } | i18n }}</p>
      <p>{{ { key: 'orderConfirmationMailInfo' } | i18n }}</p>

      <div class="sm:flex-col1 mt-12 flex">
        <button
          class="flex max-w-xs flex-1 items-center justify-center rounded-md border border-transparent bg-primary-600 py-3 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-gray-50 sm:w-full"
          [routerLink]="'/shop'"
        >
          {{ { key: 'backToShop' } | i18n }}
        </button>
      </div>
    }
    @case (BbitPaymentRedirectState.FAILED) {
      <div class="flex flex-row items-center mb-6">
        <ng-icon name="heroXCircle" size="32px" class="mr-4 text-red-600"></ng-icon>
        <h1 class="mb-0">{{ { key: 'errorWhileCreatingOrder' } | i18n }}</h1>
      </div>

      <p>{{ { key: 'orderFailedInfo' } | i18n }}</p>
    }
    @case (BbitPaymentRedirectState.CANCEL) {
      <div class="flex flex-row items-center mb-6">
        <ng-icon name="heroXCircle" size="32px" class="mr-4 text-gray-500"></ng-icon>
        <h1 class="mb-0">{{ { key: 'paymentCanceled' } | i18n }}</h1>
      </div>

      <p>{{ { key: 'paymentCanceledInfo' } | i18n }}</p>

      <div class="sm:flex-col1 mt-12 flex">
        <button
          class="flex max-w-xs flex-1 items-center justify-center rounded-md border border-transparent bg-primary-600 py-3 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-gray-50 sm:w-full"
          [routerLink]="'/shop'"
        >
          {{ { key: 'backToCart' } | i18n }}
        </button>
      </div>
    }
    @default {
      <div class="flex flex-row items-center mb-6">
        <ng-icon name="heroXCircle" size="32px" class="mr-4 text-gray-500"></ng-icon>
        <h1 class="mb-0">{{ { key: 'unknownState' } | i18n }}</h1>
      </div>

      <div class="sm:flex-col1 mt-12 flex">
        <button
          class="flex max-w-xs flex-1 items-center justify-center rounded-md border border-transparent bg-primary-600 py-3 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-gray-50 sm:w-full"
          [routerLink]="'/shop'"
        >
          {{ { key: 'backToCart' } | i18n }}
        </button>
      </div>
    }
  }
</div>
